<script>
  export default {
    name: 'app-footer',
    data () {
      return {}
    },
    computed: {},
    mounted () {
    },
    destroyed () {
    },
    methods: {},
    components: {}
  }
</script>

<template>
    <footer id="footer" class="app-footer hidden-print" role="footer">
        <div class="wrapper b-t bg-light"> <span class="pull-right">0.0.1 <a class="m-l-sm text-muted"><i class="fa fa-long-arrow-up"></i></a></span> IntranetCorp Wtis © {{new Date().getFullYear()}} Copyright. </div>
    </footer>
</template>



// WEBPACK FOOTER //
// Footer.vue?e6fb6372